// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__M6d6o","row":"ProcedureTreatmentSummary_row__16RXt"};